import {Card} from "react-bootstrap";
import React, {useContext} from "react";
import {SoknaderContext} from "./contexts/SoknaderContext";

function ArbeidsforholdCard(props:any){

    const {soknad, setSoknad, poststed, employmentTypes, fylker, errors} = useContext(SoknaderContext);
    const readOnly:boolean = props.readOnly;

    return(
        <Card>
            <Card.Header className={"bg-primary card-header-ext"}>
                Arbeidsforhold
            </Card.Header>
            <Card.Body>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Ansettelsesform</label>
                    <div className="col-md-10">
                        <select
                            className="form-select form-select-sm"
                            disabled={readOnly}
                            value={soknad?.employmenttypeId}
                            onChange={(e: any) => {
                                setSoknad({...soknad, employmenttypeId: e.target.value})
                            }}
                        >
                            <option></option>
                            {
                                employmentTypes.map((x: any) => {
                                    return <option key={x.id} value={x.id}>{x.name}</option>
                                })
                            }
                        </select>
                        {errors?.employmenttypeId && <span className={"validation-error"}>{errors.employmenttypeId}</span>}
                    </div>
                </div>
                {/* eslint-disable-next-line eqeqeq */}
                {soknad.employmenttypeId == 7 ?
                    <div className="form-group row mb-2">
                        <label className="col-md-2 col-form-label col-form-label-sm">Spesifiser
                            annet</label>
                        <div className="col-md-10">
                            <input
                                type="text"
                                className="form-control form-control-sm"
                                readOnly={readOnly}
                                value={soknad?.employmentTypeOther}
                                onChange={(e: any) => {
                                    setSoknad({...soknad, employmentTypeOther: e.target.value})
                                }}
                            />
                            {errors?.employmentTypeOther && <span className={"validation-error"}>{errors.employmentTypeOther}</span>}
                        </div>
                    </div>
                    : null}

                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Arbeidssted</label>
                    <div className="col-md-10">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.placeOfWork}
                            onChange={(e: any) => {
                                setSoknad({...soknad, placeOfWork: e.target.value})
                            }}
                        />
                        {errors?.placeOfWork && <span className={"validation-error"}>{errors.placeOfWork}</span>}
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Adresse</label>
                    <div className="col-md-10">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.workAddress}
                            onChange={(e: any) => {
                                setSoknad({...soknad, workAddress: e.target.value})
                            }}
                        />
                        {errors?.workAddress && <span className={"validation-error"}>{errors.workAddress}</span>}
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Postnr</label>
                    <div className="col-md-2">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.workPostalCode}
                            onChange={(e: any) => {
                                if (e.target.value.length === 4) {
                                    const pnr = e.target.value;
                                    poststed(pnr).then((x: string) => {

                                        setSoknad({...soknad, workPostalCode: pnr, workCity: x})
                                    })
                                } else {
                                    setSoknad({...soknad, workPostalCode: e.target.value})
                                }
                            }}
                        />
                        {errors?.workPostalCode && <span className={"validation-error"}>{errors.workPostalCode}</span>}
                    </div>
                    <label className="col-md-2 col-form-label col-form-label-sm">Poststed</label>
                    <div className="col-md-6">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.workCity}
                            onChange={(e: any) => {
                                setSoknad({...soknad, workCity: e.target.value})
                            }}
                        />
                        {errors?.workCity && <span className={"validation-error"}>{errors.workCity}</span>}
                    </div>
                </div>
                <div className="form-group row mb-2">
                    <label className="col-md-2 col-form-label col-form-label-sm">Kommune</label>
                    <div className="col-md-4">
                        <input
                            type="text"
                            className="form-control form-control-sm"
                            readOnly={readOnly}
                            value={soknad?.workCounty}
                            onChange={(e: any) => {
                                setSoknad({...soknad, workCounty: e.target.value})
                            }}
                        />
                        {errors?.workCounty && <span className={"validation-error"}>{errors.workCounty}</span>}
                    </div>
                    <label className="col-md-2 col-form-label col-form-label-sm">Fylke</label>
                    <div className="col-md-4">
                        <select
                            className="form-select form-select-sm"
                            disabled={readOnly}
                            value={soknad?.workState}
                            onChange={(e: any) => {
                                setSoknad({...soknad, workState: e.target.value})
                            }}
                        >
                            <option></option>
                            {
                                fylker.map((x: any) => {
                                    return <option key={x.fylkesnavn}
                                                   value={x.fylkesnavn}>{x.fylkesnavn}</option>
                                })
                            }
                        </select>
                        {errors?.workState && <span className={"validation-error"}>{errors.workState}</span>}
                    </div>
                </div>
            </Card.Body>
        </Card>
    )
}

export default ArbeidsforholdCard